import type { Stripe } from '@stripe/stripe-js';

const stripePromises = new Map<string, Promise<Stripe | null>>();

export const getStripe = (isSlateVehicle: boolean) => {
  const stripePublishableKey = isSlateVehicle
    ? process.env.SLATE_STRIPE_PUBLISHABLE_KEY
    : process.env.STRIPE_PUBLISHABLE_KEY;

  if (!stripePublishableKey) {
    return null;
  }

  const existingPromise = stripePromises.get(stripePublishableKey);

  if (existingPromise) {
    return existingPromise;
  }

  const stripePromise = import('@stripe/stripe-js').then(({ loadStripe }) =>
    loadStripe(stripePublishableKey, {
      developerTools: { assistant: { enabled: false } }
    })
  );

  stripePromises.set(stripePublishableKey, stripePromise);

  return stripePromise;
};
